const url = typeof window !== 'undefined' ? window?.location?.href : '';
const testOmsId = url.match(/[0-9]{9}/g);
const omsId = testOmsId ? testOmsId[0] : null;
export default omsId;
